module.exports = __webpack_public_path__ + "static/media/Plurall_logo.84376fdd.png";